import moment from 'utils/cops-moment';
import { announcementPublishOptions } from '../../../utils/app-configs';

export const getStandalonePublishDetails = (standaloneMode) => {
  let publishOptionToSelect = announcementPublishOptions.immediateInfinite;
  let startDate = null;
  let endDate = null;

  if (standaloneMode?.startDate && standaloneMode?.endDate) {
    publishOptionToSelect = announcementPublishOptions.specific;
    startDate = {
      date: moment(standaloneMode.startDate),
      hour: moment(standaloneMode.startDate),
      minute: moment(standaloneMode.startDate),
    };
    endDate = {
      date: moment(standaloneMode.endDate),
      hour: moment(standaloneMode.endDate),
      minute: moment(standaloneMode.endDate),
    };
  }

  return {
    publishOptionToSelect,
    startDate,
    endDate,
  };
};

export const getStandaloneDefaults = (standaloneMode) => {
  const defaultScope =
    standaloneMode?.wizardServiceCenters?.find(e => e?.isDefault) ||
    standaloneMode?.wizardServiceCenters?.[0];

  const defaultBeforeSeverity =
    standaloneMode?.beforeAnnouncement?.wizardSeverities?.find(e => e?.isDefault) ||
    standaloneMode?.beforeAnnouncement?.wizardSeverities?.[0];
  const defaultDuringSeverity =
    standaloneMode?.duringAnnouncement?.wizardSeverities?.find(e => e?.isDefault) ||
    standaloneMode?.duringAnnouncement?.wizardSeverities?.[0];
  const defaultAfterSeverity =
    standaloneMode?.afterAnnouncement?.wizardSeverities?.find(e => e?.isDefault) ||
    standaloneMode?.afterAnnouncement?.wizardSeverities?.[0];

  const defaultBeforeTemplate =
    standaloneMode?.beforeAnnouncement?.wizardTemplates?.find(e => e?.isDefault) ||
    standaloneMode?.beforeAnnouncement?.wizardTemplates?.find(e => e?.uid === 'none');
  const defaultDuringTemplate =
    standaloneMode?.duringAnnouncement?.wizardTemplates?.find(e => e?.isDefault) ||
    standaloneMode?.duringAnnouncement?.wizardTemplates?.find(e => e?.uid === 'none');
  const defaultAfterTemplate =
    standaloneMode?.afterAnnouncement?.wizardTemplates?.find(e => e?.isDefault) ||
    standaloneMode?.afterAnnouncement?.wizardTemplates?.find(e => e?.uid === 'none');

  return {
    scope: defaultScope,
    before: {
      severity: defaultBeforeSeverity,
      template: defaultBeforeTemplate,
    },
    during: {
      severity: defaultDuringSeverity,
      template: defaultDuringTemplate,
    },
    after: {
      severity: defaultAfterSeverity,
      template: defaultAfterTemplate,
    },
  };
};
